import React,{ useState,useEffect, useRef  } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../../firebase';
import { doc, getDoc, query, where, getDocs, collection,addDoc,serverTimestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

import {
  BookOpen,
  Brain,
  Pencil,
  Camera,
  Bot,
  Calculator,
  Image,
  Shapes,
  ChevronRight,
  Home,
  ClipboardList,
  Upload,
  MoreHorizontal,
  Download,
  Share,
  User,
  UserPlus,
  FileText,
  Trophy
} from "lucide-react";

export default function Layout({ children,profileExists, userName, persona, handleNavigation, handleLogout }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [sharedCount, setSharedCount] = useState(0);
  
  useEffect(() => {
    const fetchSharedWorksheetsCount = async () => {
      const currentUser = auth.currentUser;
      if (!currentUser) return;
  
      try {
        // 1️⃣ Fetch shared worksheets
        const sharedQuery = query(
          collection(db, "Shared_Worksheets"),
          where("friendEmail", "==", currentUser.email)
        );
  
        const sharedSnapshot = await getDocs(sharedQuery);
  
        // Deduplicate shared by fileUrl
        const sharedFileUrls = new Set();
  
        sharedSnapshot.docs.forEach((docSnap) => {
          const data = docSnap.data();
          if (data.fileUrl) {
            sharedFileUrls.add(data.fileUrl);
          }
        });
  
        // 2️⃣ Fetch downloaded worksheets
        const downloadQuery = query(
          collection(db, "Downloads_And_Generations"),
          where("email", "==", currentUser.email)
        );
  
        const downloadSnapshot = await getDocs(downloadQuery);
  
        // Deduplicate downloads by fileUrl
        const downloadedFileUrls = new Set();
  
        downloadSnapshot.docs.forEach((docSnap) => {
          const data = docSnap.data();
          if (data.fileUrl) {
            downloadedFileUrls.add(data.fileUrl);
          }
        });
  
        // 3️⃣ Subtract downloaded from shared
        let remainingCount = 0;
  
        sharedFileUrls.forEach((fileUrl) => {
          if (!downloadedFileUrls.has(fileUrl)) {
            remainingCount++;
          }
        });
  
        setSharedCount(remainingCount);
  
      } catch (error) {
        console.error("Error fetching shared worksheets:", error);
      }
    };
  
    fetchSharedWorksheetsCount();
  }, []);
  

  return (
// 1. Ensure the root container is min-h-screen and uses 'flex'
    <div className="relative min-h-screen bg-[#F4F6FA] flex ">
      
      <div className="relative z-10 flex-1 flex flex-col w-full">
        {/* Sidebar */}
        <Sidebar
          open={sidebarOpen}
          setOpen={setSidebarOpen}
          profileExists={profileExists}
          userName={userName}
          persona={persona}
          handleNavigation={handleNavigation}
          handleLogout={handleLogout}
        />

        {/* Main Section */}
        <div className="lg:pl-64 flex flex-col flex-1 w-full">
          
          {/* 2. THE TOPBAR: Added sticky classes here to ensure it stays pinned */}
          <div className="sticky top-0 z-[60] w-full">
          <Topbar setOpen={setSidebarOpen} sharedCount={sharedCount} />
          </div>



          {/* 3. Main Content: Removed extra pt-6 if you want it to sit flush, 
              or kept it for spacing. flex-1 ensures it pushes footer down */}
          <main className="flex-1 px-0 sm:px-6 lg:px-8 pb-20 lg:pb-8 pt-4 md:pt-6">
            {children}
          </main>

          {/* Bottom Mobile Navigation */}
          <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around py-3 lg:hidden z-50"></div> <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around py-3 lg:hidden z-50">     <button className="flex flex-col items-center text-[#4F7DF3] text-xs"
            onClick={() => {handleNavigation("/ReferFriend");}}>
              <Share className="w-5 h-5 mb-1" />
              Share Eascode
            </button>

            <button className="flex flex-col items-center text-[#4F7DF3] text-xs"
            onClick={() => handleNavigation('/TestResultsDashboard')}>
              <Trophy className="w-5 h-5 mb-1" />
              My Quiz Results
            </button>

            <button
              className="flex flex-col items-center justify-center text-[#4F7DF3] text-xs -mt-6"
              onClick={() => handleNavigation("/EascodeChat")}
            >
              <span className="w-16 h-16 rounded-full bg-white border border-blue-100 shadow-lg flex items-center justify-center">
                <img
                  src="/Eascode_No_Background.png"
                  alt="Eascode Chat"
                  className="w-full h-full object-contain rounded-full"
                />
              </span>
            <p className="text-sm font-black text-blue-600 mt-1 notranslate">
              Easy
            </p>
            </button>

            <button className="flex flex-col items-center text-[#4F7DF3] text-xs"
            onClick={() => handleNavigation('/UserUploadsPage')}>              
              <Upload className="w-5 h-5 mb-1" />
              My Uploads
            </button>

            <button className="flex flex-col items-center text-[#4F7DF3] text-xs"
            onClick={() => handleNavigation('/UserDownloadPage')}>              
              <Download className="w-5 h-5 mb-1" />
              My Downloads
            </button>

{/*
            <div>
              <button
                className="flex flex-col items-center text-[#4F7DF3] text-xs"
                onClick={() =>
                  handleNavigation('/download-forms', {
                    type: 'All Types',
                    subject: 'All Subjects',
                    shared: true
                  })
                }
              >
                
                <div className="relative">
                  <Download className="w-5 h-5" />

                  
                  <div
                    className="
                      absolute -top-2 -right-2
                      bg-red-500 text-white
                      text-[10px] font-bold
                      w-6 h-6
                      flex items-center justify-center
                      shadow-md
                    "
                    style={{
                      clipPath:
                        "polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)"
                    }}
                  >
                    {sharedCount}
                  </div>
                </div>

                <span className="mt-1">Received Worksheets</span>
              </button>
            </div>

            <button
              className="flex flex-col items-center text-[#4F7DF3] text-xs"
              onClick={
                profileExists
                  ? () => handleNavigation("/edit-profile", { persona })
                  : () =>
                      handleNavigation("/create-profile", {
                        state: { persona },
                      })
              }
            >
              {profileExists ? (
                <User className="w-5 h-5 mb-1" />
              ) : (
                <UserPlus className="w-5 h-5 mb-1" />
              )}

              {profileExists ? "Edit Profile" : "Create Profile"}
            </button>
*/}
            </div>

        </div>

      </div>
    </div>
  );
}